import React from "react"
import { cn } from "./cn"

// Tailwind replacement for react-bootstrap <Alert variant=...>.
const VARIANTS = {
  primary: "bg-green-50 text-integria-green border-integria-green/30",
  secondary: "bg-gray-50 text-gray-700 border-gray-200",
  success: "bg-green-50 text-green-800 border-green-200",
  danger: "bg-red-50 text-red-800 border-red-200",
  warning: "bg-yellow-50 text-yellow-800 border-yellow-200",
  info: "bg-sky-50 text-sky-800 border-sky-200",
}

export default function Alert({ variant = "primary", className = "", children, ...props }) {
  const v = VARIANTS[variant] || VARIANTS.primary
  return (
    <div
      role="alert"
      className={cn("rounded border p-3 text-sm", v, className)}
      {...props}
    >
      {children}
    </div>
  )
}
